$(function() {
    // As of writing, only used by collection group page to filter collectionGroupMemberComponent list. Refactor required to be more general
    var allItems = $('.govuk-list--spaced.expandable-list li');
    var filteredItems = allItems;

    function filterItems(selectedOrg) {
        if (selectedOrg === 'ALL') {
            filteredItems = allItems;
        } else {
            filteredItems = allItems.filter(function() {
                return $(this).data('org-ids').split(',').includes(selectedOrg);
            });
        }

        $(document).trigger('itemsFiltered', [filteredItems]);
    }

    $('#selectOrg').on('change', function() {
        var selectedOrg = $(this).val();
        filterItems(selectedOrg);
    });

    filterItems('ALL');
});